import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const Sun: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <path fill="currentColor" d="M3.8,5.2c.4-.6.9-1,1.4-1.4l-1.5-1.5c-.4-.4-1-.4-1.4,0-.4.4-.4,1,0,1.4l1.5,1.5Z" />
            <path fill="currentColor" d="M15,7h-2.1c.1.7.1,1.3,0,2h2.1c.6,0,1-.4,1-1s-.4-1-1-1Z" />
            <path fill="currentColor" d="M9,3.1V1c0-.6-.4-1-1-1s-1,.4-1,1v2.1c.7-.1,1.3-.1,2,0Z" />
            <path fill="currentColor" d="M12.2,5.2l1.5-1.5s0,0,0,0c.4-.4.4-1,0-1.4-.4-.4-1-.4-1.4,0l-1.5,1.5c.6.4,1,.9,1.4,1.4Z" />
            <path fill="currentColor" d="M3.1,7H1c-.6,0-1,.4-1,1s.4,1,1,1h2.1c-.1-.7-.1-1.3,0-2Z" />
            <circle fill="currentColor" cx="8" cy="8" r="3" />
            <path fill="currentColor" d="M3.8,10.8l-1.5,1.5c-.4.4-.4,1,0,1.4.4.4,1,.4,1.4,0l1.5-1.5c-.6-.4-1-.9-1.4-1.4Z" />
            <path fill="currentColor" d="M12.2,10.8c-.4.6-.9,1-1.4,1.4l1.5,1.5s0,0,0,0c.4.4,1,.4,1.4,0s.4-1,0-1.4l-1.5-1.5Z" />
            <path fill="currentColor" d="M7,12.9v2.1c0,.6.4,1,1,1s1-.4,1-1v-2.1c-.7.1-1.3.1-2,0Z" />
        </Icon>
    );
};
